module.exports = __webpack_public_path__ + "img/m1.b4de65b2.png";